module.exports = __webpack_public_path__ + "media/theme/how-it-works-close-04-a30c44da.png";